import { cn } from "@/lib/utils";

export interface EmptyStateProps {
  message?: string;
  title?: string;
  description?: string;
  className?: string;
  action?: React.ReactNode;
  icon?: React.ReactNode;
  align?: 'center' | 'left' | 'right';
}

/**
 * Displays a placeholder state when no content is available
 * @param message - The main message to display
 * @param title - Optional title above the message
 * @param description - Optional description below the message
 * @param className - Additional CSS classes
 * @param action - Optional action button/link
 * @param icon - Optional icon to display
 * @param align - Alignment of the content ('center' | 'left' | 'right')
 */
export function EmptyState({ 
  message, 
  title, 
  description, 
  className, 
  action, 
  icon,
  align = 'center' 
}: EmptyStateProps) {
  return (
    <div className={cn(
      "flex flex-col p-8",
      align === 'center' && "items-center justify-center",
      align === 'left' && "items-start",
      align === 'right' && "items-end",
      "text-muted-foreground",
      className
    )}>
      {icon && (
        <div className="mb-4 text-muted-foreground">
          {icon}
        </div>
      )}
      {title && (
        <h3 className="text-lg font-semibold text-foreground mb-2">
          {title}
        </h3>
      )}
      {message && <p className="text-center">{message}</p>}
      {description && (
        <p className="text-sm mt-1 text-muted-foreground">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
